import { InjectionToken } from '@angular/core';
import { PorIconModel } from '@por/icon-lib/icons';

export const POR_SVG_ICONS = new InjectionToken<PorIconModel[]>('POR_SVG_ICONS');
